import { sqItemTableDefinitionStore } from '@/core/core.stores';
import { BaseTableEditorStore } from '@/tableDefinitionEditor/baseTableEditorStore';
import type { BaseTableEditorDehydratedStoreState } from '@/tableDefinitionEditor/baseTableEditorStore';
import type { ColumnDefinition } from '@/tableDefinitionEditor/tableDefinition.types';

export type ItemTableEditorDehydratedState = BaseTableEditorDehydratedStoreState;

export class ItemTableEditorStore extends BaseTableEditorStore {
  static readonly storeName = 'sqItemTableEditorStore';

  override initialize() {
    super.initialize();
    this.state.set('visibleControlPane', 'hierarchy');
  }

  get columnToEdit(): ColumnDefinition | undefined {
    return this.getColumnToEdit({
      columnToEditId: this.columnToEditId,
      existingColumns: sqItemTableDefinitionStore.columns,
    });
  }

  override dehydrate(): ItemTableEditorDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ItemTableEditorDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  override handlers = {
    ITEM_SET_TABLE_ID: this.setTableId,
    ITEM_RESET_TABLE_EDITOR_STORE: this.reset,
    ITEM_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    ITEM_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    ITEM_SET_COLUMN_TO_EDIT_ID: this.setColumnToEditId,
    ITEM_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    ITEM_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    ITEM_SET_SHORTCUT_SOURCE_COLUMN: this.setShortcutSourceColumn,
    ITEM_SET_CONTROL_PANE: this.setControlPane,
    ITEM_SET_INITIAL_COLUMN_RULE: this.setInitialColumnRule,
    ITEM_SET_SHOW_STORED_TABLE_SEARCH_WARNING: this.setShowStoredTableSearchWarning,
    ITEM_SET_SHOW_CHILD_LIMIT_EXCEEDED_WARNING: this.setShowChildLimitExceededWarning,
  };
}
